export const ACTIONS = {
    SET_LOADING: 'SET_LOADING',
    SET_ERROR: 'SET_ERROR',
    CLEAR_ERROR: 'CLEAR_ERROR',
    SET_BRANCH_CODES: 'SET_BRANCH_CODES',
    SET_SELECTED_BRANCH_CODE: 'SET_SELECTED_BRANCH_CODE',
    ADD_BRANCH_CODE: 'ADD_BRANCH_CODE',
    UPDATE_BRANCH_CODE: 'UPDATE_BRANCH_CODE',
    DELETE_BRANCH_CODE: 'DELETE_BRANCH_CODE',
    SET_FILTER: 'SET_FILTER',
    SET_SORT: 'SET_SORT',
    SET_PAGE: 'SET_PAGE'
};

export const initialState = {
    branchCodes: [],
    selectedBranchCode: null,
    loading: false,
    error: null,
    filter: {
        name: null,
        code: null,
        status: null,
        type: null
    },
    pagination: {
        page: 0,
        size: 10,
        total: 0
    },
    sort: {
        field: 'name',
        direction: 'asc'
    },
    lastUpdated: null
};

export const branchCodeReducer = (state, action) => {
    switch (action.type) {
        case ACTIONS.SET_LOADING:
            return { ...state, loading: action.payload };

        case ACTIONS.SET_ERROR:
            return { ...state, error: action.payload, loading: false };

        case ACTIONS.CLEAR_ERROR:
            return { ...state, error: null };

        case ACTIONS.SET_BRANCH_CODES:
            return {
                ...state,
                branchCodes: action.payload.content,
                pagination: {
                    ...state.pagination,
                    total: action.payload.totalElements || (Array.isArray(action.payload) ? action.payload.length : 0),
                    page: action.payload.number || 0
                },
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_SELECTED_BRANCH_CODE:
            return { ...state, selectedBranchCode: action.payload, loading: false };

        case ACTIONS.ADD_BRANCH_CODE:
            return {
                ...state,
                branchCodes: [action.payload, ...state.branchCodes],
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.UPDATE_BRANCH_CODE:
            return {
                ...state,
                branchCodes: state.branchCodes.map((branchCode) =>
                    branchCode.id === action.payload.id ? action.payload.data : branchCode
                ),
                selectedBranchCode: state.selectedBranchCode?.id === action.payload.id ? action.payload.data : state.selectedBranchCode,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.DELETE_BRANCH_CODE:
            return {
                ...state,
                branchCodes: state.branchCodes.filter((branchCode) => branchCode.id !== action.payload),
                selectedBranchCode: state.selectedBranchCode?.id === action.payload ? null : state.selectedBranchCode,
                lastUpdated: new Date().toISOString(),
                loading: false
            };

        case ACTIONS.SET_FILTER:
            return {
                ...state,
                filter: {
                    ...state.filter,
                    ...action.payload
                },
                pagination: {
                    ...state.pagination,
                    page: 0 // Reset page to 0 when filter changes
                }
            };

        case ACTIONS.SET_SORT:
            return {
                ...state,
                sort: action.payload
            };

        case ACTIONS.SET_PAGE:
            return {
                ...state,
                pagination: {
                    ...state.pagination,
                    ...action.payload
                }
            };

        default:
            return state;
    }
};
